import { CopyOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { message } from 'antd';
import { ReturnOrderListItemV2 } from 'services/api/refund';
import copyText from 'utils/copyText';
import { useMemoizedFn } from 'ahooks';

interface DisplayNumberProps {
  data: ReturnOrderListItemV2;
}

export const DisplayNumber = (props: DisplayNumberProps) => {
  const {
    data: { returnSn, orderSn },
  } = props;
  const { t } = useTranslate();

  const handleReturnSnCopy = useMemoizedFn(() => {
    copyText(returnSn).then(() => message.success(t('common.feedback.copySuccess')));
  });
  const handleOrderSnCopy = useMemoizedFn(() => {
    copyText(orderSn).then(() => message.success(t('common.feedback.copySuccess')));
  });

  return (
    <>
      <div className="inline-flex items-center group relative" onClick={handleReturnSnCopy}>
        {t('scene.orderWorkspace.returnRefundTab.detail.field.refundId')}: {returnSn}
        <CopyOutlined className="absolute top-1 -right-3.5 invisible group-hover:visible" />
      </div>
      <div className="inline-flex items-center group relative" onClick={handleOrderSnCopy}>
        {t('scene.orderWorkspace.returnRefundTab.list.column.orderId')}: {orderSn}
        <CopyOutlined className="absolute top-1 -right-3.5 invisible group-hover:visible" />
      </div>
    </>
  );
};
